import React from 'react';

/** «2 de 3» discreto junto a un botón de «Nuevo…». Nada con Plus. */
export const ContadorLimite: React.FC<{ texto: string }> = ({ texto }) =>
  texto ? <span className="text-xs font-normal opacity-80 tabular-nums">({texto})</span> : null;
